module.exports = __webpack_public_path__ + "static/media/Løk-min.8974c7aa.PNG";